import { Navigate } from "react-router-dom";

const STRIPE_URL = "https://buy.stripe.com/3cIeVcfGAcLu1CFeTqgrS0e";

export default function Access() {
    const token = localStorage.getItem("token");
    if (!token) return <Navigate to="/auth/login" replace />;

    if (localStorage.getItem("accessCodeValidated") === "false")
        return <Navigate to="/auth/access-code" replace />;

    const isSub = localStorage.getItem("isSub") === "true";
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    const trialEndsAt = localStorage.getItem("trialEndsAt");
    const trialExpired = trialEndsAt && new Date(trialEndsAt) < new Date();

    if (!isAdmin && !isSub && trialExpired) {
        window.location.href = STRIPE_URL;
        return null;
    }

    return <Navigate to="/dashboard" replace />;
}
